import { CircularProgress, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  downloadUnitPerformanceReport,
  getSubordinateContracts,
} from "../../../store/rbm/actions";
import SubordinateCard from "../components/SubordinateCard";
import ReactPaginate from "react-paginate";

const MySubordinateContracts = (props) => {
  const {
    loading,
    getSubordinateContracts,
    subordinateContracts,
    selectedFiscalYear,
    selectedPlanningEntityId,
    isNotActive = false,
  } = props;

  useEffect(() => {
    document.title = `IPPIS - RBM My ${
      isNotActive ? "Active" : "Exited"
    } Subordinate Contracts`;
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      isNotActive,
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };

    if (!!selectedFiscalYear.id)
      getSubordinateContracts(query, setTotalRecords, setLoader);
  }, [selectedFiscalYear?.id, isNotActive, selectedPlanningEntityId]);

  const getNo = (idToSearch) => {
    return subordinateContracts.findIndex(({ id }) => id === idToSearch);
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      isNotActive,
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getSubordinateContracts(query, setTotalRecords, setLoader);
  };

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        isNotActive,
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };

      getSubordinateContracts(query, setTotalRecords, setLoader);
    }
  };

  return (
    <>
      {/* <div className="row no-gutter justify-content-center">
        <div className="col-12 col-lg-11 px-0 px-md-3">
          <div className="rbm-shadow rounded px-4 py-3"> */}
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          value={searchTerm}
          id="filter"
          placeholder="Search..."
          onChange={(e) => onSearch(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              const query = {
                searchTerm: searchTerm,
                page: currentPage,
                size: itemPerPage,
              };

              getSubordinateContracts(query, setTotalRecords, setLoader);
            }
          }}
        />
      </div>

      {subordinateContracts &&
        subordinateContracts.map((subordinate) => (
          <SubordinateCard
            key={subordinate.id + subordinate.contractId || ""}
            index={getNo(subordinate.id)}
            subordinate={subordinate}
            refreshOnChange={() => {
              const query = {
                searchTerm: searchTerm,
                page: currentPage,
                size: itemPerPage,
              };

              getSubordinateContracts(query, setTotalRecords, setLoader);
            }}
          />
        ))}

      {!subordinateContracts[0] && loading && (
        <div>
          <Skeleton variant="rectangular" className="mb-3 mt-2" height={118} />
          <Skeleton variant="rectangular" className="mb-3" height={96} />
          <Skeleton variant="rectangular" className="mb-3" height={96} />
          <Skeleton variant="rectangular" className="mb-3" height={96} />
        </div>
      )}

      {!subordinateContracts[0] && !loading && (
        <div className="jumbotron jumbotron-fluid text-center">
          <div className="container">
            <p className="lead">No subordinate found.</p>
          </div>
        </div>
      )}

      <div
        className="d-flex justify-content-center  align-items-center"
        style={{ overflow: "hidden" }}
      >
        <div className="mt-3">
          <ReactPaginate
            breakLabel="..."
            nextLabel={
              <>
                <span className="pr-1 d-none d-md-inline">Next</span>
                <i className="fas fa-angle-double-right"></i>
              </>
            }
            previousLabel={
              <>
                <i className="fas fa-angle-double-left"></i>
                <span className="pl-1  d-none d-md-inline">Previous</span>
              </>
            }
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageCount={Math.ceil(totalRecords / itemPerPage)}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
            previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
            nextLinkClassName="btn btn-outline-info btn-sm ml-1"
            activeLinkClassName="active"
          />
        </div>

        {!!subordinateContracts.length && (
          <select
            className="custom-select custom-select-sm mr-3 ml-2"
            style={{ width: "100px" }}
            value={itemPerPage}
            onChange={(event) => {
              const itemPerPage = +event.target.value;
              setItemPerPage(itemPerPage);
              const query = {
                searchTerm: searchTerm,
                page: currentPage,
                size: itemPerPage,
              };
              getSubordinateContracts(query, setTotalRecords, setLoader);
            }}
          >
            {[5, 10, 50].map((item, index) => (
              <option key={index}>{item}</option>
            ))}
          </select>
        )}
      </div>
      {/* </div>
        </div>
      </div> */}

      <div
        className={`page-loading-void position-fixed ${
          loader && !!subordinateContracts[0] ? "d-block" : "d-none"
        }`}
      >
        {loader && (
          <CircularProgress
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              color: "rgb(7, 142, 206)",
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
            size={40}
            thickness={4}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  loading,
  subordinateContracts,
  selectedFiscalYear,
  selectedPlanningEntityId,
}) => {
  return {
    loading,
    subordinateContracts,
    selectedFiscalYear,
    selectedPlanningEntityId,
  };
};

export default connect(mapStateToProps, {
  getSubordinateContracts,
  downloadUnitPerformanceReport,
})(MySubordinateContracts);
